import React from "react";
import { Tabs } from "antd";
import SignInAdmin from "../admin/SignInAdmin";
import SignInStudent from "../students/SignInStudent";
import SignInProfessor from "../professors/SignInProfessor";

const TabPane = Tabs.TabPane;

export default class signInTabs extends React.Component {
  callback = key => {};

  render() {
    return (
      <Tabs defaultActiveKey="1" onChange={this.callback}>
        <TabPane tab="Estudiantes" key="1">
          <SignInStudent />
        </TabPane>
        <TabPane tab="Profesores" key="2">
          <SignInProfessor />
        </TabPane>
        <TabPane tab="Administradores" key="3">
          <SignInAdmin />
        </TabPane>
      </Tabs>
    );
  }
}
